let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7r4Mk")).then(() => parcelRequire('4JJyB'));